import { render } from "./IdInquiry.vue?vue&type=template&id=51eccde1"
import script from "./IdInquiry.vue?vue&type=script&lang=js"
export * from "./IdInquiry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__